import { Role } from '../auth/models/role.model';

export class Invitation {
  /** Agree's internal unique identifier. */
  readonly id: number;
  email: string;
  role: Role;
  readonly message: string;
}
